import { useContext } from 'react';
import { AnalyticsContext } from '../context/analytics-context';

/**
 * @description The returns a track function allows the consumer to track an
 * event independent of the useEffect call, for example, in a event handler.
 */
export const useAnalyticsTrack = () => useContext(AnalyticsContext);
